module.exports = [{"type":"quest","quest":"ramen-ya","stage":"found-shop","journal":"It's been a while since you last had a meal. Why not grab a bite?","filters":[{"type":"structure-nearby","structure":"food-court-ramen"},{"type":"flag","flag":"discovered:airport-food-court-ramen","value":false}],"effects":[{"type":"discover","location":"airport-food-court-ramen"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/food-court.json
// module id = 163
// module chunks = 0